<template>
    <div style="height: 100%;">
        <router-view/>
        <van-tabbar v-model="active" :placeholder="true" :safe-area-inset-bottom="true">
            <van-tabbar-item  to="/beautyheadstaffcopy" icon="bar-chart-o">
                <span>负责顾客</span>
            </van-tabbar-item>
            <van-tabbar-item  to="/beautystaffexaminedetal" icon="manager-o">
                <span>绩效考核</span>
            </van-tabbar-item>
            <van-tabbar-item  to="/beautyxflog" icon="manager-o" :badge="ccount">
                <span>我的日志</span>
            </van-tabbar-item>
            <van-tabbar-item  to="/beautystaffdata" icon="manager-o">
                <span>我的数据</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
    </template>
    <script>
        export default {
            data(){
                return {
                    active:0,
                    ccount:0,
                }
            },
            created() {
                this.getNotXfLogCardtransHistory();
            },
            methods:{
                getNotXfLogCardtransHistory(){
                    this.$post("beautymanager/getNotXfLogCardtransHistory",{storeid:localStorage.getItem("storeid"),staffid:localStorage.getItem("staffid")}).then(res=>{
                        if(res.sucess){
                            this.ccount=0;
                            if(res.object!=null && res.object.length>0){
                                this.ccount=res.object.length;
                            }
                        }
                        else{
                            this.$message({
                                message: res.message,
                                type: 'error'
                            });
                        }
                    });
                },
            }
        }
    </script>


// WEBPACK FOOTER //
// src/page/beauty/beautystafftabbar.vue